import React, { useEffect, useState } from "react";
import styles from "./article-category.module.css";
import Loader from "../../../../components/Loader";
import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";
import { Helmet } from "react-helmet";
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, Slide, Snackbar, TablePagination, Typography } from "@mui/material";
import { ArrowLeft, Home, X } from "react-feather";
import Footer from "../../../../components/Footer";
import ArticleCategoryCard from "./components/ArticleCategoryCard";
import ArticleCategoryFilter from "./components/ArticleCategoryFilter";
import { TableLoader } from "../../../../components/LoaderC";
import axios from "axios";
import ArticleCategoryAdd from "./components/ArticleCategoryAdd";
import { AddLogCallAPI } from "../../../../components/AddLogs";
import { toast } from 'react-smart-toaster';


const ArticleCategoryList = ({ history, match }) => {
    const { getAccessTokenSilently } = useAuth0();
    const [loading, setLoading] = useState(false);
    const [contentLoading, setContentLoading] = useState(true);
    const [showAddForm, setShowAddForm] = useState(false);
    const [showdeletePopup, setShowdeletePopup] = useState(false);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMsg, setSnackbarMsg] = useState("");
    const [allCategoryList, setAllCategoryList] = useState([]);
    const [categoryList, setCategoryList] = useState([]);
    const [page, setPage] = useState(0);
    const [perPage, setPerPage] = useState(8);
    const [filterData, setFilterData] = useState({ searchKey: "" });
    const [selectecId, setSelectecId] = useState(0);

    useEffect(() => {
        async function getAllCategories() {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

            axios(process.env.REACT_APP_RESOURCE_API_URL + "v1/article-categories", {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }).then((response) => {
                setContentLoading(false);
                setAllCategoryList(response.data.data);
            }).catch((error) => {
                setContentLoading(false);
            });
        }
        getAllCategories();
    }, [getAccessTokenSilently]);

    useEffect(() => {
        if (allCategoryList.length > 0) {
            let filteredData = allCategoryList;

            if (filterData.searchKey !== "") {
                let inputVal = filterData.searchKey;
                inputVal = inputVal.toLowerCase();
                filteredData = filteredData.filter((item) => {
                    return (item.title.toLowerCase().includes(inputVal));
                });
            }

            setCategoryList(filteredData);
        } else {
            setCategoryList([]);
        }
    }, [filterData, allCategoryList]);

    const onAdd = (data) => {
        setAllCategoryList((prev) => {
            return [data].concat(prev);
        });
    }

    const confirmDelete = async () => {
        setShowdeletePopup(false);
        setLoading(true);
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        axios.delete(process.env.REACT_APP_RESOURCE_API_URL + 'v1/article-categories/' + selectecId, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then(response => {
            setSnackbarOpen(true);
            setSnackbarMsg(response.data.message);
            setLoading(false);

            setAllCategoryList(prev => {
                let updateList = prev?.filter(i => i?.id !== selectecId);
                return updateList;
            })
            setSelectecId(0);

            let logData = {
                'title': 'A KB Category is deleted',
                'description': [
                    'Title: ' + response.data.data?.title
                ]
            }

            AddLogCallAPI(logData, token);
        }).catch(error => {
            if (typeof error.response !== 'undefined')
                toast.error(error.response.data.message);
            setLoading(false);
        });
    }

    return (<React.Fragment>
        {loading && <Loader />}

        <Helmet title="Knowledge Base Category" />
        <div className={`${styles.pageTitleWrap}`}>
            <Typography display="inline" className={`${styles.pageTitle}`}>Knowledge Base Category</Typography>
            <nav aria-label="breadcrumb">
                <ol className={`${styles.breadcrumb}`}>
                    <li className={`${styles.breadcrumbItem}`}><span><Home /></span>Resources</li>
                    <li className={`${styles.breadcrumbItem} ${styles.active}`}>Knowledge Base Category</li>
                </ol>
            </nav>
        </div>

        <div className={`${styles.BodyCon}`}>
            <div className={`${styles.mainCardDiv}`}>
                <div className={`${styles.mainCard}`}>
                    <div className="control-pane">
                        {contentLoading && (<div className="Loader TableLoader"><TableLoader /></div>)}

                        {!contentLoading && (<div className={`${styles.Row}`}>
                            <ArticleCategoryFilter setFilterData={setFilterData.bind(this)} setShowAddForm={setShowAddForm.bind(this)} />

                            <div className={`${styles.NotesRow}`}>
                                {categoryList.map((item, index) => {
                                    return (perPage === -1 || (index >= page * perPage && index < page * perPage + perPage)) ? (<ArticleCategoryCard item={item} setShowdeletePopup={setShowdeletePopup.bind(this)} setSelectecId={setSelectecId.bind(this)} />) : null;
                                })}

                                {categoryList.length > 0 && (<div className="Pagination TablePaginationNew List">
                                    <TablePagination
                                        count={categoryList.length}
                                        color="primary"
                                        page={page}
                                        rowsPerPage={perPage}
                                        onPageChange={(e, v) => setPage(v)}
                                        rowsPerPageOptions={[
                                            { label: '4', value: 4 },
                                            { label: '8', value: 8 },
                                            { label: '16', value: 16 },
                                            { label: 'All', value: -1 },
                                        ]}
                                        onRowsPerPageChange={(e) => {
                                            setPage(0);
                                            setPerPage(e.target.value);
                                        }}
                                        labelRowsPerPage={'KB Category per Page:'}
                                    />
                                </div>)}

                                {!contentLoading && categoryList.length === 0 && (<div className={`${styles.NoDataMain}`}>
                                    <div className={`${styles.NoDataIMG}`}>
                                        <img src="/static/img/category-kb.png" alt="No Data" />
                                    </div>
                                    <p className={`${styles.NoDataText}`}>Oops!</p>
                                    <p className={`${styles.NoDataTextSub}`}>It seems we can't find that category.</p>
                                </div>)}
                            </div>
                        </div>)}
                    </div>
                </div>
            </div>
        </div>

        <Dialog
            open={showAddForm}
            onClose={(e) => setShowAddForm(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="NewPopUp MobileForm"
            fullWidth
            maxWidth="xs"
        >
            <DialogTitle id="alert-dialog-title">
                <button className={`${styles.BackAddBU}`} onClick={(e) => setShowAddForm(false)}><ArrowLeft /></button>
                New Category
                <button onClick={(e) => setShowAddForm(false)}><X /></button>
            </DialogTitle>
            <DialogContent>
                <ArticleCategoryAdd setShowAddForm={setShowAddForm.bind(this)} setLoading={setLoading.bind(this)} onAdd={onAdd.bind(this)} setSnackbarOpen={setSnackbarOpen.bind(this)} setSnackbarMsg={setSnackbarMsg.bind(this)} isEdit={false} selectecId={0} />
            </DialogContent>
        </Dialog>

        <Dialog
            open={showdeletePopup}
            onClose={(e) => setShowdeletePopup(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="NewPopUp"
            fullWidth
            maxWidth="sm"
        >
            <DialogTitle id="alert-dialog-title">
                Are you sure you want to delete the category?
                <button onClick={(e) => setShowdeletePopup(false)}><X /></button>
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    <div className="ModalFormGroup">
                        <label className="PopupBodyText">This category will be removed immediately. You can't undo this action.</label>
                    </div>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <button className="CancelPopupBU" onClick={(e) => confirmDelete()}>Delete</button>
                <button onClick={(e) => setShowdeletePopup(false)} className="SubmitPopupBU">Cancel</button>
            </DialogActions>
        </Dialog>

        <Snackbar
            open={snackbarOpen}
            onClose={(e) => setSnackbarOpen(false)}
            TransitionComponent={Slide}
            message={snackbarMsg}
            autoHideDuration={10000}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            action={
                <IconButton
                    size="small"
                    aria-label="close"
                    color="inherit"
                    onClick={(e) => setSnackbarOpen(false)}
                >
                    <X />
                </IconButton>
            }
        />

        <Footer />
    </React.Fragment>);
};

export default withAuthenticationRequired(ArticleCategoryList, {
    onRedirecting: () => <Loader />,
});
